/**
 * Include your custom JavaScript here.
**/
/****Add Anchor Tag Via Class ****/
    const contact__store = document.querySelector('.contact__store-image');
            const anchor = document.createElement('a');
            anchor.href = 'https://wa.me/919667624107?text=Hi%21+I+interested+in+Customisable+Poker+Chips';
            anchor.target = '_blank';
            contact__store.parentNode.replaceChild(anchor, contact__store);
       anchor.appendChild(contact__store);
/****Add Anchor Tag Via Class End ****/

/****Currency Converter Via Geo IP ****/

  // Define country-to-currency mapping
  // const countryToCurrency = {
  //   US: "USD",
  //   CA: "CAD",
  //   GB: "GBP",
  //   IN: "INR",
  //   AU: "AUD",
 
  // };

  // // Function to fetch user's country
  // async function getUserCountry() {
  //   try {
  //     const response = await fetch("https://ipapi.co/json/"); 
  //     const data = await response.json();
  //     return data.country_code; // Returns country code like 'US', 'IN', etc.
  //   } catch (error) {
  //     console.error("Geolocation API error:", error);
  //     return null;
  //   }
  // }
  // // Function to change currency based on location
  // async function changeCurrencyByLocation() {
  //   const country = await getUserCountry();
  //   if (country && countryToCurrency[country]) {
  //     const currency = countryToCurrency[country];
  //     // Shopify.currencyConverter is a built-in feature if enabled
  //     if (Shopify && Shopify.currencyConverter) {
  //       Shopify.currencyConverter.setCurrency(currency);
  //       console.log(`Currency switched to: ${currency}`);
  //     } else {
  //       console.warn("Shopify Currency Converter not available.");
  //     }
  //   } else {
  //     console.warn("Country not mapped or unable to detect country.");
  //   }
  // }

  // // Run the function on page load
  // document.addEventListener("DOMContentLoaded", changeCurrencyByLocation);

/****Currency Converter Via Geo IP End ****/

/***** Data Layer Click Event ******/

//    const getCookieByName = (name) => {
//       const match = document.cookie.match(
//          new RegExp("(^| )" + name + "=([^;]+)")
//       );
//       if (match) {
//          return match[2];
//       } else {
//          console.log("--error in getting cookie ---");
//          return null;
//       }
//    };
//    const parseJwt = (token) => {
//       try {
//          return JSON.parse(atob(token.split(".")[1]));
//       } catch (e) {
//          return null;
//       }
//    };
//    const pushToDataLayer = (options) => {
//       const {
//          eventName,
//          clickedItemText,
//          sectionName,
//          userLoginStatus,
//          registrationStatus,
//          customOptions,
//       } = options;
//       const userData = parseJwt(getCookieByName("auth-token"));
//       const userId = userData?.user_id || "";
//       const clientId = getCookieByName("_ga");
//       let eventData = {
//          ["client_id"]: clientId || "",
//          ["hit_timestamp"]: new Date().toString(),
//          event: eventName,
//          ["clicked_item_text"]: clickedItemText,
//          ["clicked_item_section"]: sectionName,
//          ["user_login_status"]: userId ? true : false,
//          ["user_registration_status"]: userId ? true : false,
//       };
//       if (userId) {
//          eventData.user_id = userId;
//       }
//       if (customOptions) {
//          eventData = { ...eventData, ...customOptions };
//       }
//       if (window.dataLayer) {
//          console.log(eventData, "dataLayer data");
//          window.dataLayer.push(eventData);
//       } else {
//          console.error("data layer not found");
//       }
//    };

//    document
//       .querySelectorAll("#block-75abd823-fb85-4c26-9bdc-34cab1b58fc0 > div > div> img")
//       .forEach((e) => {
//          e.onclick = () =>
//             pushToDataLayer({
//                eventName: "home_banner_cpb_btn",
//                clickedItemText: e.innerHTML,
//                sectionName: "HomeBanner",
//             });
//       });
// document
//       .querySelectorAll("#template--14350575435839__1658905191de17a472 > div > div > header > a")
//       .forEach((e) => {
//          e.onclick = () =>
//             pushToDataLayer({
//                eventName: "home_banner_cpb_btn",
//                clickedItemText: "Make your own chips!",
//                sectionName: "CollectionButton",
//             });
//       });
  
/*****Data Layer Click Event End*****/
/*****Hide component for country*****/
// async function getUserCountry() {
//   try {
//     // Fetch user's location using IP geolocation API
//     const response = await fetch("https://ipinfo.io/json/");
//     if (!response.ok) throw new Error("Failed to fetch location data");
//     const data = await response.json();
//     return data.country; 
//   } catch (error) {
//     console.error("Error detecting user location:", error);
//     return null; // Default to null if an error occurs
//   }
// }

// async function hideSectionForNonIndia() {
//   const country = await getUserCountry();
//   if (country !== "IN") { // Hide section for all countries except India
//     const section = document.getElementById("shopify-section-announcement-bar");
//     if (section) {
//       section.style.display = "none"; // Hide the section
//       console.log("Section hidden for non-India visitors.");
//     }
//   }
// }
// document.addEventListener("DOMContentLoaded", hideSectionForNonIndia);

/*****Hide component for country End*****/


// (function () {
//   const quantityContainer = document.querySelector(".quantity");
//   const minusBtn = quantityContainer.querySelector(".minus");
//   const plusBtn = quantityContainer.querySelector(".plus");
//   const inputBox = quantityContainer.querySelector(".input-box");

//   updateButtonStates();

//   quantityContainer.addEventListener("click", handleButtonClick);
//   inputBox.addEventListener("input", handleQuantityChange);

//   function updateButtonStates() {
//     const value = parseInt(inputBox.value);
//     minusBtn.disabled = value <= 1;
//     plusBtn.disabled = value >= parseInt(inputBox.max);
//   }

//   function handleButtonClick(event) {
//     if (event.target.classList.contains("minus")) {
//       decreaseValue();
//     } else if (event.target.classList.contains("plus")) {
//       increaseValue();
//     }
//   }

//   function decreaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.max(value - 1, 1);
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function increaseValue() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : Math.min(value + 1, parseInt(inputBox.max));
//     inputBox.value = value;
//     updateButtonStates();
//     handleQuantityChange();
//   }

//   function handleQuantityChange() {
//     let value = parseInt(inputBox.value);
//     value = isNaN(value) ? 1 : value;

//     // Execute your code here based on the updated quantity value
//     console.log("Quantity changed:", value);
//   }
// })();




/***Add to cart sticky in footer***/
// document.addEventListener("DOMContentLoaded", function () {
  
//   const stickyFooter = document.querySelector('.product-sticky-footer');
//   const triggerSection = document.querySelector('.card__section'); 
  
//   if (stickyFooter && triggerSection) {
//     window.addEventListener('scroll', function () {
//       const triggerBottom = triggerSection.getBoundingClientRect().bottom;
//       if (triggerBottom < 0) {
//         stickyFooter.classList.add('show');
//       } else {
//         stickyFooter.classList.remove('show');
//       }
//     });
//   }
// });

/***Add to cart sticky in footer***/
// document.addEventListener("DOMContentLoaded", function () {

//   const stickyFooter = document.querySelector('.product-sticky-footer');
//   const triggerSection = document.querySelector('.card__section');

//   // Scroll show/hide
//   if (stickyFooter && triggerSection) {
//     window.addEventListener('scroll', function () {
//       const triggerBottom = triggerSection.getBoundingClientRect().bottom;
//       if (triggerBottom < 0) {
//         stickyFooter.classList.add('show');
//       } else {
//         stickyFooter.classList.remove('show');
//       }
//     });
//   }

//   // Sync price with variant selector
//   document.addEventListener('variant:changed', function (event) {
//     const variant = event.detail.variant;
//     if (variant) {
//       const stickyPrice = document.getElementById('sticky-footer-price');
//       if (stickyPrice) {
//         stickyPrice.textContent = formatMoney(variant.price);
//       }
//     }
//   });

//   // Fallback: watch native select/radio inputs for variant changes
//   document.querySelectorAll('[name="id"], .variant-input, select.product-form__variants')
//     .forEach(function (input) {
//       input.addEventListener('change', function () {
//         const selectedOption = this.options ? this.options[this.selectedIndex] : null;
//         const variantId = selectedOption ? selectedOption.value : this.value;

//         fetch(`/variants/${variantId}.js`)
//           .then(res => res.json())
//           .then(variant => {
//             const stickyPrice = document.getElementById('sticky-footer-price');
//             if (stickyPrice) {
//               stickyPrice.textContent = formatMoney(variant.price);
//             }
//           });
//       });
//     });

//   // Money formatter (matches Shopify's default format)
//   function formatMoney(cents) {
//     const amount = (cents / 100).toFixed(2);
//     return '₹' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//   }

// });

document.addEventListener("DOMContentLoaded", function () {

  const stickyFooter = document.querySelector('.product-sticky-footer');
  const triggerSection = document.querySelector('.card__section');
  const stickyPrice = document.getElementById('sticky-footer-price');

  const stickyForm = document.querySelector('.sticky-product-form');

  // Scroll show/hide
  if (stickyFooter && triggerSection) {
    window.addEventListener('scroll', function () {
      const triggerBottom = triggerSection.getBoundingClientRect().bottom;
      if (triggerBottom < 0) {
        stickyFooter.classList.add('show');
      } else {
        stickyFooter.classList.remove('show');
      }
    });
  }

  // GET CURRENT VARIANT ID (FROM MAIN FORM)
  function getVariantId() {
    const mainForm = document.querySelector('form[action="/cart/add"]:not(.sticky-product-form)');
    const input = mainForm ? mainForm.querySelector('[name="id"]') : null;
    return input ? input.value : null;
  }

  // UPDATE PRICE + SYNC VARIANT
  function updateStickyData() {
    const variantId = getVariantId();
    if (!variantId) return;

    // ✅ Sync variant ID to sticky form
    if (stickyForm) {
      const stickyInput = stickyForm.querySelector('[name="id"]');
      if (stickyInput) {
        stickyInput.value = variantId;
      }
    }

    // ✅ Update price
    fetch(`/variants/${variantId}.js`)
      .then(res => res.json())
      .then(variant => {
        if (stickyPrice && variant.price) {
          stickyPrice.textContent = formatMoney(variant.price);
        }
      })
      .catch(() => {});
  }

  // LISTEN TO VARIANT CHANGE
  document.body.addEventListener('change', function (e) {
    if (
      e.target.matches('[name="id"]') ||
      e.target.matches('select') ||
      e.target.matches('input[type="radio"]')
    ) {
      setTimeout(updateStickyData, 100);
    }
  });

  // SHOPIFY EVENT (BEST SUPPORT)
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;
    if (!variant) return;

    // Update price
    if (stickyPrice) {
      stickyPrice.textContent = formatMoney(variant.price);
    }

    // Sync variant ID
    if (stickyForm) {
      const stickyInput = stickyForm.querySelector('[name="id"]');
      if (stickyInput) {
        stickyInput.value = variant.id;
      }
    }
  });

  updateStickyData();

  // FORMAT MONEY
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return '₹' + amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

});

/***Add to cart sticky in footer End***/

document.addEventListener("DOMContentLoaded", function () {
  const img = document.querySelector('#block-75abd823-fb85-4c26-9bdc-34cab1b58fc0');
  if (img) {
    img.fetchPriority = 'high';
  }
});

/***Home Page cutom video**/
  document.addEventListener("DOMContentLoaded", function () {
    const video = document.getElementById("custom-video");

    if ("IntersectionObserver" in window && video) {
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.play();
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      observer.observe(video);
    } else {
      // Fallback: play immediately
      video.play();
    }
  });
/***Home Page cutom video End***/ 

/*****Product desc show more Start******/ 

document.addEventListener("DOMContentLoaded", function () {
  const rteElements = document.querySelectorAll(".ov_product_desc .rte");

  rteElements.forEach(function (description) {
    if (description.scrollHeight > 150) {
      const toggleBtn = document.createElement("button");
      toggleBtn.textContent = "+ View more";
      toggleBtn.className = "rte-toggle";

      description.insertAdjacentElement("afterend", toggleBtn);

      toggleBtn.addEventListener("click", function () {
        description.classList.toggle("expanded");
        toggleBtn.textContent = description.classList.contains("expanded")
          ? "- View less"
          : "+ View more";
      });
    }
  });
});
/****Product desc show more End****/


    /**** Chip Parallax Start****/
    window.addEventListener('scroll', () => {
    // 1. Grab all sections that should have this effect
    const parallaxSections = document.querySelectorAll('.ov-parallax-section');

    parallaxSections.forEach(section => {
        const sectionRect = section.getBoundingClientRect();
        
        // 2. Check if THIS specific section is visible
        if (sectionRect.top < window.innerHeight && sectionRect.bottom > 0) {
            
            const scrollProgress = window.innerHeight - sectionRect.top;
            
            // 3. Only find chips INSIDE this specific section
            const chips = section.querySelectorAll('.ov-chip');

            chips.forEach(chip => {
                const speed = parseFloat(chip.getAttribute('data-speed'));
                const rotSpeed = parseFloat(chip.getAttribute('data-rotation'));
                
                const style = getComputedStyle(chip);
                const rx = style.getPropertyValue('--rx').trim() || '0deg';
                const ry = style.getPropertyValue('--ry').trim() || '0deg';
                const baseRz = parseFloat(style.getPropertyValue('--rz')) || 0;

                const yMove = scrollProgress * speed;
                const dynamicRz = baseRz + (scrollProgress * rotSpeed);
                
                chip.style.transform = `translate3d(0, ${yMove}px, 0) rotateX(${rx}) rotateY(${ry}) rotateZ(${dynamicRz}deg)`;
            });
        }
    });
});
    /**** Chip Parallax End****/